var _ada_ = {};

window.Ada = {
  isFocusOutFromParent: function(event, parent) {
		const {target, relatedTarget} = event;

		if(!target || !relatedTarget)
			return;

		if(parent.contains(relatedTarget))
			return false;
		return true;
	},

  adaUtility: {
		// last resort for popup trigger
		// if they are not specified
		setTriggerForPopup: function(trigger) {
			_ada_.trigger = trigger;
		},

		getTriggerForPopup: function() {
			return _ada_.trigger;
		},

		associateToggleAndDropdown: function(toggle, dropdown) {
			var id = dropdown.getAttribute('id');
			if(!id) {
				id =  Core.uuid();
				dropdown.setAttribute('id', id);
			}
			toggle.setAttribute('aria-controls', id);
			toggle.addEventListener('click', e => {
				var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
				if(isExpanded)
					toggle.removeAttribute('aria-expanded');
				else
					toggle.setAttribute('aria-expanded', true);
			})
		}
	},

  // for modals
	// when modal is open, we dont allow uer to tab outside of the content
	disableTabbingOutside: function(element, hideFnc) {
		if(!element)
			return;
		const handleKeydown = event => {
			const tabElementsNodelist = element.querySelectorAll('a, button, input');
			let tabElements = [].slice.call(tabElementsNodelist);
			tabElements = tabElements.filter(d => {
				return d.getAttribute('disabled') !== 'disabled' && d.offsetParent !== null
			});
			if (event.ctrlKey || event.metaKey || event.altKey){
				return;
			}

			switch (event.which) {
				case 27:
					hideFnc && hideFnc();
					event.preventDefault();
					break;
				case 9:
					if (event.shiftKey) {
						if (document.activeElement === tabElements[0]) {
						tabElements[tabElements.length - 1].focus();
						event.preventDefault();
						}
					} else {
						if (document.activeElement === tabElements[tabElements.length - 1]) {
							tabElements[0].focus();
							event.preventDefault();
						}
					}
				break;
			}
		}

		element.addEventListener('keydown', handleKeydown);
		// return clear function so we can remove it when the element gets unmounted
		return () => element.removeEventListener('keydown', handleKeydown);
	},

  uuid: function() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/x|y/g, function(xy) {
			var r = Math.floor(Math.random()*16);
			return (xy === 'x' ? r : (r & 3 | 8)).toString(16);
		});
	},

	handleSkipToContent: function() {
		var ele = document.querySelector('.skip-to-content');
		ele.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			var target = document.querySelector('#skip-to-content');
			target.focus();
		})
	}
}

// temporarally setting Core to be ada on mobile
// to be compoatible with other existing code
// There is nothing more permanent than temporary
if(typeof isMobile !== 'undefined' && isMobile) {
  // for mobile Core is undefined
  window.Core = window.Ada;
}